import React from "react";
import Header from "../layouts/Employee/Header";
import SubHeader from "../layouts/Employee/SubHeader";
import OvertimeListLayout from "../layouts/Employee/OvertimeListLayout";

const OvertimeList = () => {
  return (
    <>
      <Header />
      <SubHeader />
      <OvertimeListLayout />
    </>
  );
};

export default OvertimeList;
